import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd038aService,
  Sgkd038aRequest,
  Sgkd038aResponse,
  Sgkd038aRequestUpdateInfoArea
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd010dSgkd038aService {

  private _rsesult$ = new Subject<Sgkd038aResponse>();

  constructor(
    private sgkd038aService: Sgkd038aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 請求料金関連情報登録更新API呼び出し
   * @param updateInfoArea 更新情報エリア
   * @memberof UsedSgkd010dSgkd038aService
   */
  update(updateInfoArea: Array<Sgkd038aRequestUpdateInfoArea>): Observable<Sgkd038aResponse> {

    // リクエスト生成
    let request: Sgkd038aRequest = {
      requestDto: {
        updateInfoAreaList: updateInfoArea
      }
    };

    return this.sgkd038aService.doSGKD038APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD038A');
          return throwError(err.message);
        }
      )
    );
  }
}
